<template>
  <div class="flex md12 contact-infos">
    <div class="row">
      <div class="flex md3">
        <va-select
          label="Titre"
          v-model="selectTitre"
          :options="titreOptions"
          no-clear
        />
      </div>
      <div class="flex md5">
        <va-input
          v-model="contactInfosMod.nom"
          placeholder="Contact inconnu"
          label="Nom"
          :error="validName"
        />
      </div>
      <div class="flex md4">
        <va-input
          v-show="selectTitre !== 'SOCIÉTÉ'"
          :disabled="selectTitre === 'SOCIÉTÉ'"
          v-model="contactInfosMod.prenom"
          placeholder="-"
          label="Prénom"
        />
      </div>
    </div>
    <div class="row" v-if="selectTitre === 'SOCIÉTÉ'">
      <div class="flex md3">
        <va-select
          label="Titre contact"
          v-model="selectTitreSociete"
          :options="titreOptionsSociete"
          no-clear
        />
      </div>
      <div class="flex md5">
        <va-input
          v-model="contactInfosMod.nom_societe"
          placeholder="Contact inconnu"
          label="Nom contact"
        />
      </div>
      <div class="flex md4">
        <va-input
          v-model="contactInfosMod.prenom_societe"
          placeholder="-"
          label="Prénom contact"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual, find } from "lodash";

export default {
  props: ["contactInfos"],

  data() {
    return {
      infosUpdated: false,
      contactInfosMod: {
        idcontact: null,
        entreprise_identreprise: null,
        titre: null,
        nom: null,
        prenom: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
      },
      selectTitreSociete: "",
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      selectTitre: "",
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
    };
  },
  mounted() {},
  methods: {},
  computed: {
    isFormValid: function () {
      if (this.validName) {
        return false;
      }
      return true;
    },
    validName: function () {
      if (
        !this.contactInfosMod.nom &&
        (this.contactInfosMod.titre || this.contactInfosMod.prenom)
      )
        return true;
      return false;
    },
    validSurname: function () {
      return false;
    },
  },
  watch: {
    selectTitre(newtitre) {
      this.contactInfosMod.titre = newtitre;
    },
    selectTitreSociete(newtitre) {
      this.contactInfosMod.titre_societe = newtitre;
    },
    contactInfosMod: {
      deep: true,
      handler() {
        if (!isEqual(this.contactInfosMod, this.contactInfos)) {
          this.$emit("infosChanged", true);
          this.infosUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infosUpdated = false;
        }
      },
    },
    contactInfos(newContact) {
      if (newContact) {
        this.contactInfosMod = cloneDeep(newContact);
        this.selectTitre = newContact.titre ? newContact.titre : "";
        this.selectTitreSociete = newContact.titre_societe
          ? newContact.titre_societe
          : "";
      }
    },
  },
};
</script>

<style lang="scss">
.contact-infos > * > .flex {
  padding-left: 0.25rem;
}
</style>
